export default obj =>
  Object.keys(obj).map(key => Object.assign({ key }, obj[key]));



// WEBPACK FOOTER //
// ./src/common/utils/object-to-array.js